import get from 'lodash/get';

const selectTourFinished = (state) => get(state, 'preferences.tourFinished', false);

export default selectTourFinished;
